import languages from "./en/languages";

export  default {
    languages,
}
